import { CalendarToday } from '@mui/icons-material';
import { Box, Chip, Grid, Paper, Typography } from '@mui/material';
import React from 'react';

interface ImportantDatesProps {
  quoteDate: string;
  startDate: string;
  endDate: string;
}

const ImportantDates: React.FC<ImportantDatesProps> = ({
  quoteDate,
  startDate,
  endDate,
}) => {
  return (
    <Paper
      sx={{
        p: 1.5,
        boxShadow: 'none',
        border: '1px solid #e0e0e0',
        mb: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          mb: 1.5,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1rem',
            lineHeight: 1.1,
          }}
        >
          Fechas Importantes
        </Typography>
        <Chip
          label="Cronología"
          size="small"
          color="primary"
          variant="outlined"
          sx={{ height: '18px', fontSize: '0.65rem' }}
        />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                backgroundColor: 'rgba(25, 118, 210, 0.1)',
                borderRadius: '50%',
                p: 0.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CalendarToday
                sx={{ fontSize: '0.8rem', color: 'primary.main' }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: '0.65rem' }}
              >
                Fecha de Cotización
              </Typography>
              <Typography
                variant="body2"
                fontWeight="medium"
                sx={{ fontSize: '0.75rem' }}
              >
                {quoteDate}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                backgroundColor: 'rgba(76, 175, 80, 0.1)',
                borderRadius: '50%',
                p: 0.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CalendarToday
                sx={{ fontSize: '0.8rem', color: 'success.main' }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: '0.65rem' }}
              >
                Fecha de Inicio
              </Typography>
              <Typography
                variant="body2"
                fontWeight="medium"
                sx={{ fontSize: '0.75rem' }}
              >
                {startDate}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                backgroundColor: 'rgba(244, 67, 54, 0.1)',
                borderRadius: '50%',
                p: 0.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CalendarToday sx={{ fontSize: '0.8rem', color: 'error.main' }} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: '0.65rem' }}
              >
                Fecha de Término
              </Typography>
              <Typography
                variant="body2"
                fontWeight="medium"
                sx={{ fontSize: '0.75rem' }}
              >
                {endDate}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ImportantDates;
